import axios from "axios";
import React from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as HomeHeroEllipsGroupSvg } from "../../assets/landingPages/homePage/homeHeroEllipsGroup.svg";
import { ReactComponent as StarVectorSvg } from "../../assets/landingPages/homePage/starShape.svg";
import { ReactComponent as StarVectorSvgDark } from "../../assets/landingPages/homePage/starShapeDark.svg";
import WaitingUserPageImage from "../../assets/landingPages/WaitingUserPageImage.webp";
import { useSelector } from "react-redux";
import useLocales from "../../hooks/useLocales";
const VerifyEmail = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const { email, code } = useParams();

  const getEmail = async () => {
    try {
      const path = `/api/user/verify-email/${email}/${code}`;
      const url = baseUrl + path;
      const response = await axios.get(url);
      if (response?.data?.status === "failed") {
        toast.error(response.data.message);
      } else if (response?.data?.status === "success") {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error("Full error object:", error);
      console.error("Error message:", error.message);
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getEmail();
  }, []);
  return (
    <>
      <section
        className={`flex  bg-[#fbf7f7] -mt-[93px] pt-[93px] items-center justify-center relative dark:bg-dark-primary`}
      >
        <div className="absolute bottom-0 right-0 ">
          <HomeHeroEllipsGroupSvg className="h-[16rem] w-auto max-h-[16rem] sm:max-h-[493px] md:max-h-[350px] xl:max-h-[470px] sm:h-auto" />
        </div>
        <div className="absolute hidden xl:block lg:left-6 xl:left-20 lg:top-16 xl:top-40">
          {darkMode ? (
            <StarVectorSvgDark className="lg:h-10 xl:h-14" />
          ) : (
            <StarVectorSvg className="lg:h-10 xl:h-14" />
          )}
        </div>
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg">
          <div className="">
            <div
              className={`px-3  sm:px-9 flex h-full flex-col lg:flex-row gap-12 sm:gap-16 lg:gap-6 items-center lg:pt-14 lg:py-16 xl:pt-16 xl:py-20 2xl:pt-14 2xl:py-24 pt-[60px] pb-[70px] relative`}
            >
              <div className="w-full flex-col lg:w-[60%]">
                <h1 className="mb-3 text-custom_h4 sm:text-custom_h3 md:text-custom_h2 2xl:text-custom_h1 text-heading_color dark:text-color_v1_dark">
                  {translate("be_the_first_to")}
                  <br />
                  {translate("experience")}
                  &nbsp;
                  <span className="relative text-main_color">
                    {translate("bil_bio")}
                  </span>
                </h1>
                <p className="mb-8 xsmfold:text-small2_b text-body_copy_medium_color text-small2 sm:text-body_copy1 dark:text-color_v2_dark">
                  {translate("waitlist_early_access")}
                </p>
                <div className="flex w-full">
                  <svg
                    className="-mt-8"
                    width="72"
                    height="72"
                    viewBox="0 0 72 72"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ width: "140px", height: "140px" }}
                  >
                    <path
                      d="M48.375 29.25L31.8749 45L23.625 37.125"
                      stroke="#05B737"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M36 63C50.9117 63 63 50.9117 63 36C63 21.0883 50.9117 9 36 9C21.0883 9 9 21.0883 9 36C9 50.9117 21.0883 63 36 63Z"
                      stroke="#05B737"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <div className="ml-4">
                    <p className="text-custom_h6 text-main_color">
                      {translate("you_are_waitlist")}
                    </p>
                    <p className="mt-4 xsmfold:text-small2 sm:text-body_copy1 text-body_copy1 text-body_copy_medium_color dark:text-color_v2_dark">
                      {translate("thanks_joining_waitlist")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-[40%] flex justify-center xl:justify-end relative">
                <div className="relative">
                  <img
                    src={WaitingUserPageImage}
                    className="xsmm:max-h-[24rem] max-h-[21rem] sm:max-h-[38rem] lg:max-h-[32rem] xl:max-h-[35rem] 2xl:max-h-[38rem] z-20"
                    alt="..."
                    title="..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VerifyEmail;
